/**
 * DC2.0 trigger names for the Security & Password page. Fired on
 * `window.LIFE_CYCLE_EVENT_BUS`; the listeners live in aape_Voltron and must
 * match these names exactly.
 */
export const SECURITY_TRIGGERS = {
  PAGE_LOAD: "security.page-load",
  PAGE_ERROR: "security.page-error",
  STASH_EVENT: "security.stash-event",
  SUBMISSION_EVENT: "security.submission-event",
  SETTINGS_SUBMISSION_EVENT: "security.settings-submission-event",
  WEBAUTHN_SETTINGS_EVENT: "security.webauthn-settings-event",
  ERROR_EVENT: "security.error-event",
  OVERLAY_EVENT: "security.overlay-event",
} as const;

export default SECURITY_TRIGGERS;
